import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ChangeClient from '@/pages/change-client/ChangeClient.vue';

export default {
  path: '/change-client',
  name: 'ChangeClient',
  components: {
    mainContent: ChangeClient,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'change-client',
    },
    breadcrumb: {
      title: 'Configurações',
      paths: [{ title: 'Troca de cliente' }],
    },
  },
};
